import RestricaoPadraoService from "@/services/RestricaoPadraoService";

export const restricaoPadrao = {
  namespaced: true,
  state: {
    restricaoPadrao: {},
  },
  actions: {
    getRestricaoPadrao({ commit }, payload) {
      return RestricaoPadraoService.GetRestricaoPadrao(payload).then(
        (restricaoPadrao) => {
          return Promise.resolve(restricaoPadrao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postRestricaoPadrao({ commit }, payload) {
      return RestricaoPadraoService.PostRestricaoPadrao(payload).then(
        (restricaoPadrao) => {
          return Promise.resolve(restricaoPadrao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putRestricaoPadrao({ commit }, payload) {
      return RestricaoPadraoService.PutRestricaoPadrao(payload).then(
        (restricaoPadrao) => {
          return Promise.resolve(restricaoPadrao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteRestricaoPadrao({ commit }, payload) {
      return RestricaoPadraoService.DeleteRestricaoPadrao(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getRestricaoPadraoOData({ commit }, payload) {
      return RestricaoPadraoService.GetRestricaoPadraoOData(payload).then(
        (restricaoPadrao) => {
          return Promise.resolve(restricaoPadrao);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default restricaoPadrao;
